const KpiCard = ({ title, value, accent = "blue" }) => {

  const styles = {
    blue: {
      bg: "bg-blue-50",
      text: "text-blue-600",
      sub: "text-blue-400"
    },
    red: {
      bg: "bg-red-50",
      text: "text-red-500",
      sub: "text-red-400"
    },
    orange: {
      bg: "bg-orange-50",
      text: "text-orange-500",
      sub: "text-orange-400"
    },
    gray: {
      bg: "bg-gray-50",
      text: "text-gray-500",
      sub: "text-gray-400"
    }
  }

  const style = styles[accent]

  return (
    <div className={`rounded-2xl px-5 py-4 ${style.bg}`}>
      <p className={`text-sm font-medium ${style.sub}`}>
        {title}
      </p>

      <h2 className={`mt-2 text-3xl font-bold tracking-tight ${style.text}`}>
        {value}
      </h2>
    </div>
  )
}

export default KpiCard